import atom from '@/app/editor/iframe/atom';
import { app } from '@/store';
import { mutations } from '@modules/libraries/store/types';
import config from '@/app/editor/config';
import emitter from '@/emitter';

(function (jQuery) {
  jQuery.gfQuickBar = function (element, options) {
    const defaults = {};
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    let $actionAddSingle;
    let $actionExplore;
    let $closeColumnsBtn;

    let $divNewBlock;
    let $divActions;
    let isBlankPage = app.$store.state['editor'].isBlankPage;

    /* Editor */

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    let imgURL = `${config.domain()}${config.baseURL()}/static/block/new-block.png`;

    this.renderQuickBarHtml = function () {
      const section = `<div class="gf_new-actions gf_new-actions-page-default" style="display: block">
          <p class="gf_start-building">Start building your page</p>
          <div class="gf_section-action">
            <a href="#" class="gf_section-action__explore gf_action__explore_block">Explore Blocks</a>
            <a href="#" class="gf_section-action__single">Add Single Section</a>
          </div>
          <p class="gf_drag-drop">or Drag & Drop elements from left sidebar</p>
        </div>`;

      const section2 = `<div class="gf_new-actions gf_new-actions-page-blank" style="display: block">
            <p class="gf_start-building">Start building your page</p>
            <div style="margin-bottom: 24px">
                <img id="block-img" src="${imgURL}" alt="">
            </div>
            <div class="gf_section-action">
                <a href="#" class="gf_section-action__explore gf_action__explore_template">Explore Template</a>
            </div>
            <p class="gf_drag-drop">or Drag & Drop elements from left sidebar</p>
        </div>`;

      const _html = `<div id="divNewBlock" style="display: block !important;">
      <div class="gf_column-type">
        <span class="gf_select-layout-title">Select your layout</span>
        <div class="select-type">
          <div class="select-type-col">
            <a class="select-column" data-cells="12">
              <span class="column-12"></span>
            </a>
          </div>
          <div class="select-type-col">
            <a class="select-column" data-cells="6+6">
              <span class="column-6"></span> <span class="column-6"></span>
            </a>
          </div>
          <div class="select-type-col">
            <a class="select-column" data-cells="4+4+4">
              <span class="column-4"></span> <span class="column-4"></span>
              <span class="column-4"></span>
            </a>
          </div>
          <div class="select-type-col">
            <a class="select-column" data-cells="3+3+3+3">
              <span class="column-3"></span> <span class="column-3"></span>
              <span class="column-3"></span> <span class="column-3"></span>
            </a>
          </div>
          <div class="select-type-col">
            <a class="select-column" data-cells="8+4">
              <span class="column-8"></span> <span class="column-4"></span>
            </a>
          </div>
          <div class="select-type-col">
            <a class="select-column" data-cells="4+8">
              <span class="column-4"></span> <span class="column-8"></span>
            </a>
          </div>
          <div class="select-type-col">
            <a class="select-column" data-cells="3+9">
              <span class="column-3"></span> <span class="column-9"></span>
            </a>
          </div>
          <div class="select-type-col">
            <a class="select-column" data-cells="9+3">
              <span class="column-9"></span> <span class="column-3"></span>
            </a>
          </div>
          <div class="select-type-col">
            <a class="select-column" data-cells="6+3+3">
              <span class="column-6"></span> <span class="column-3"></span>
              <span class="column-3"></span>
            </a>
          </div>
          <div class="select-type-col">
            <a class="select-column" data-cells="3+3+6">
              <span class="column-3"></span> <span class="column-3"></span>
              <span class="column-6"></span>
            </a>
          </div>
          <div class="select-type-col">
            <a class="select-column" data-cells="3+6+3">
              <span class="column-3"></span> <span class="column-6"></span>
              <span class="column-3"></span>
            </a>
          </div>
          <div class="select-type-col">
            <a class="select-column" data-cells="100">
                                <span class="column-12">
                                  <svg height="9px" viewBox="0 0 62 9">
                                    <path
                                      d="M61.7,4.5l-4.4,4.4l-0.7-0.7L59.8,5H2.2l3.1,3.1L4.6,8.9L0.3,4.5l4.4-4.4l0.7,0.7L2.2,4h57.6l-3.1-3.1l0.7-0.7 L61.7,4.5z"
                                      style="fill: #fff"
                                    />
                                  </svg>
                                </span>
            </a>
          </div>
        </div>
        <a href="#" class="gf-closecolumns">
          <svg
            width="13px"
            height="13px"
            viewBox="0 0 13 13"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <!-- Generator: Sketch 46 (44423) - http://www.bohemiancoding.com/sketch -->
            <desc>Created with Sketch.</desc>
            <defs></defs>
            <g
              id="GP-.Editor"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g
                id="GP-.Editor-.Library-.SavedDesigns2"
                transform="translate(-918.000000, -15.000000)"
                stroke-width="2"
                stroke="#8A8A8F"
              >
                <g id="Group" transform="translate(919.000000, 16.000000)">
                  <g id="Page-1">
                    <path
                      d="M10.9720525,0.587436933 L0.587436933,10.9720525"
                      id="Stroke-1"
                    ></path>
                    <path
                      d="M0.587436933,0.587436933 L10.9720525,10.9720525"
                      id="Stroke-3"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </a>
      </div>
      ${section}
      ${section2}
    </div>`;
      $element.append(_html);
    };

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      _this.renderQuickBarHtml();

      $divNewBlock = $element.find('#divNewBlock');
      emitter.on('editor:resize-screen', (size) => {
        if (size === 'xs') {
          imgURL = `${config.domain()}${config.baseURL()}/static/block/new-block-mobile.png`;
          $divNewBlock.find('.gf_section-action').css({
            'flex-direction': 'column',
          });

          $divNewBlock.find('.gf_action__explore_block').css({
            'margin-bottom': '16px',
          });
        } else {
          imgURL = `${config.domain()}${config.baseURL()}/static/block/new-block.png`;
          $divNewBlock.find('.gf_section-action').css({
            'flex-direction': 'inherit',
          });

          $divNewBlock.find('.gf_action__explore_block').css({
            'margin-bottom': '0',
          });
        }

        $divNewBlock.find('#block-img').attr('src', imgURL);
      });

      function showHideSection(blankPage) {
        if (!blankPage) {
          $divNewBlock.find('.gf_start-building').hide();
          $divNewBlock.find('.gf_new-actions-page-blank').hide();
          $divNewBlock.find('.gf_new-actions-page-default').show();
        } else {
          $divNewBlock.find('.gf_new-actions-page-blank').show();
          $divNewBlock.find('.gf_new-actions-page-default').hide().removeClass('show');
        }
      }

      emitter.on('page:blank', (isBlank) => {
        showHideSection(isBlank);
      });

      showHideSection(isBlankPage);
      $actionAddSingle = $divNewBlock.find('.gf_section-action__single');
      $actionAddSingle.on('click', function () {
        jQuery(this).closest('.gf_new-actions').removeClass('show').siblings('.gf_column-type').addClass('show');
        return false;
      });

      const $actionExploreTemplate = $divNewBlock.find('.gf_action__explore_template');
      $actionExploreTemplate.on('click', function () {
        app.$store.commit(`library/${mutations.TOGGLE}`, true);
        app.$store.commit(`library/${mutations.CHANGE_LAYOUT}`, 'default');
        app.$store.commit(`library/${mutations.CHANGE_TAB}`, 'templates');

        return false;
      });

      const $actionExploreBlock = $divNewBlock.find('.gf_action__explore_block');
      $actionExploreBlock.on('click', function () {
        app.$store.commit(`library/${mutations.TOGGLE}`, true);
        app.$store.commit(`library/${mutations.CHANGE_LAYOUT}`, 'default');
        app.$store.commit(`library/${mutations.CHANGE_TAB}`, 'blocks');
        return false;
      });

      $closeColumnsBtn = $divNewBlock.find('.gf-closecolumns');
      $closeColumnsBtn.on('click', function () {
        jQuery(this)
          .closest('.gf_column-type')
          .removeClass('show')
          .siblings('.gf_new-actions-page-default')
          .addClass('show');
        return false;
      });

      $divNewBlock
        .find('a.select-column')
        .off('click')
        .on('click', function () {
          let value = jQuery(this).attr('data-cells');
          if (value == 100) {
            // full width
            var $newRow = jQuery(
              '<div data-label="Row" data-key="row" class="gf_row gf_row-fluid gf_row-no-padding"></div>',
            );
            value = 12;
          } else {
            var $newRow = jQuery('<div data-label="Row" data-key="row" class="gf_row"></div>');
          }
          // $newRow.insertBefore($divNewBlock).gfRow();
          atom.Init($newRow.insertBefore($divNewBlock));
          const cText = (value + '').replace(/\s+/g, '');

          $newRow.data('gfrow').setRowLayout(cText);
          _this.resetColumnSize($newRow, cText);

          // History
          setTimeout(function () {
            const $currentTargetElement = $newRow;
            let $itemContent;
            let position = {};
            if ($gryffEditor.data('gfhistory')) {
              position = $gryffEditor.data('gfhistory').getPosition($itemContent, $currentTargetElement);
            }
            const history = {
              id: $currentTargetElement.attr('id'),
              action: 'add',
              position: position,
            };
            $gryffEditor.trigger('history', history);
          }, 300);

          // to update placeholder
          setTimeout(function () {
            $gryffEditor.data('gryffeditor').updatePlaceHolders();
            $gryffEditor.parents('html, body').animate(
              {
                scrollTop: $newRow.offset().top - 80,
              },
              800,
            );
          }, 50);

          return false;
        });
      return false;
    };
    this.init();

    //Reset reponsive layout when adding new row
    _this.resetColumnSize = function ($newRow, cText) {
      if ($newRow.data('gfrow')) {
        const columnSizeHolder = $newRow.children('.gf_column');
        switch (cText) {
          case '12':
            break;
          case '6+6':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-6 gf_col-md-6 gf_col-sm-6 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-6 gf_col-md-6 gf_col-sm-6 gf_col-xs-12');
            break;
          case '4+4+4':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-4 gf_col-md-4 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-4 gf_col-md-4 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(2).attr('class', 'gf_column gf_col-lg-4 gf_col-md-4 gf_col-sm-12 gf_col-xs-12');
            break;
          case '3+3+3+3':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-6 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-6 gf_col-xs-12');
            columnSizeHolder.eq(2).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-6 gf_col-xs-12');
            columnSizeHolder.eq(3).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-6 gf_col-xs-12');
            break;
          case '8+4':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-8 gf_col-md-8 gf_col-sm-6 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-4 gf_col-md-4 gf_col-sm-6 gf_col-xs-12');
            break;
          case '4+8':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-4 gf_col-md-4 gf_col-sm-6 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-8 gf_col-md-8 gf_col-sm-6 gf_col-xs-12');
            break;
          case '3+9':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-6 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-9 gf_col-md-9 gf_col-sm-6 gf_col-xs-12');
            break;
          case '9+3':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-9 gf_col-md-9 gf_col-sm-6 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-6 gf_col-xs-12');
            break;
          case '6+3+3':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-6 gf_col-md-6 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(2).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-12 gf_col-xs-12');
            break;
          case '3+3+6':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(2).attr('class', 'gf_column gf_col-lg-6 gf_col-md-6 gf_col-sm-12 gf_col-xs-12');
            break;
          case '3+6+3':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-6 gf_col-md-6 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(2).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-12 gf_col-xs-12');
            break;
        }
      }
    };
  };
  jQuery.fn.gfQuickBar = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfquickbar')) {
        const plugin = new jQuery.gfQuickBar(this, options);
        jQuery(this).data('gfquickbar', plugin);
      }
    });
  };
})(jQuery);
